import { FilePreview } from 'models/File';
import httpClient from '../httpClient';
import { PaginatedData, PaginationParams } from 'models/PaginatedData';
import {
  AnalyticsExportParams,
  DataRoomNodeReport,
  DataRoomReport,
  ReportExportParams,
  ReportFilterType,
  TrackFileUploadErrorPayload,
} from 'router/subrouters/DataRoom/subrouters/Reports/pages/Reports/types';

function getReports(
  dataRoomId: string,
  params?: PaginationParams &
    ReportFilterType & { createdAt?: { $lte?: string; $gte?: string } },
) {
  return httpClient.get<PaginatedData<DataRoomReport>>(
    `data-room-reports/data-rooms/${dataRoomId}`,
    {
      params,
    },
  );
}

function getReportByNodeActivity(
  dataRoomId: string,
  params?: PaginationParams,
) {
  return httpClient.get<PaginatedData<DataRoomNodeReport>>(
    `data-room-node-reports/data-rooms/${dataRoomId}/by-nodes`,
    {
      params,
    },
  );
}

function getReportByMemberActivity(
  dataRoomId: string,
  params?: PaginationParams,
) {
  return httpClient.get<PaginatedData<DataRoomNodeReport>>(
    `data-room-node-reports/data-rooms/${dataRoomId}/by-members`,
    {
      params,
    },
  );
}

function getReportsForNode(dataRoomNodeId: string, params?: PaginationParams) {
  return httpClient.get<PaginatedData<DataRoomNodeReport>>(
    `data-room-node-reports/data-room-nodes/${dataRoomNodeId}`,
    {
      params,
    },
  );
}

function getPdfReport(dataRoomId: string, params?: ReportExportParams) {
  return httpClient.get<FilePreview>(
    `data-room-reports/data-rooms/${dataRoomId}/export-pdf`,
    { params },
  );
}

function getCsvReport(dataRoomId: string, params?: ReportExportParams) {
  return httpClient.get<FilePreview>(
    `data-room-reports/data-rooms/${dataRoomId}/export-csv`,
    { params },
  );
}

function trackFileUploadError(
  dataRoomId: string,
  payload: TrackFileUploadErrorPayload,
) {
  return httpClient.post(
    `data-room-reports/data-rooms/${dataRoomId}/track-file-upload-error`,
    payload,
  );
}

function exportAnalytics(dataRoomId: string, data: AnalyticsExportParams) {
  return httpClient.post<FilePreview>(
    `data-room-reports/data-rooms/${dataRoomId}/export-analytics`,
    data,
  );
}

export default {
  getReports,
  getReportByNodeActivity,
  getReportByMemberActivity,
  getReportsForNode,
  getPdfReport,
  getCsvReport,
  trackFileUploadError,
  exportAnalytics,
};
